import { getStripePublishableKey } from '#pplx/frontend/billing/stripeKeys.js';
import * as BUILD_CAPABILITIES from '#pplx/frontend/deployment-capabilities/build.js';
import { useWebPlatform } from '#pplx/frontend/platform-components/useWebPlatform.js';
import { match } from '@formatjs/intl-localematcher';
import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
// TODO: We should generate this list from the StripeElementLocale and CheckoutLocale type
const STRIPE_LOCALES = [
    'ar',
    'bg',
    'cs',
    'da',
    'de',
    'el',
    'en',
    'en-AU',
    'en-CA',
    'en-NZ',
    'en-GB',
    'es',
    'es-ES',
    'es-419',
    'et',
    'fi',
    'fil',
    'fr',
    'fr-CA',
    'fr-FR',
    'he',
    'hu',
    'hr',
    'id',
    'it',
    'it-IT',
    'ja',
    'ko',
    'lt',
    'lv',
    'ms',
    'mt',
    'nb',
    'nl',
    'no',
    'pl',
    'pt',
    'pt-BR',
    'ro',
    'ru',
    'sk',
    'sl',
    'sv',
    'th',
    'tr',
    'vi',
    'zh',
    'zh-HK',
    'zh-TW',
];
async function loadStripeSdk() {
    return import('@stripe/stripe-js').then(({ loadStripe }) => loadStripe);
}
export const useGetStripePromise = ({ enableCardDetailsChange = false, } = {}) => {
    const { env: { isLocalhost, isProduction, isStaging }, } = useWebPlatform();
    const { locale } = useIntl();
    return useCallback(() => {
        if (!BUILD_CAPABILITIES.payments)
            return Promise.resolve(null);
        const bestMatchStripeLocale = match([locale], STRIPE_LOCALES, 'en');
        const key = getStripePublishableKey({ isLocalhost, isProduction, isStaging });
        const betas = ['custom_checkout_tax_id_1'];
        if (enableCardDetailsChange) {
            // Stripe still gates carddetailschange behind this beta, despite exposing its public types.
            betas.push('change_event_improvements_beta_1');
        }
        return loadStripeSdk().then((loadStripe) => loadStripe(key, {
            locale: bestMatchStripeLocale,
            betas,
        }));
    }, [enableCardDetailsChange, isLocalhost, isProduction, isStaging, locale]);
};
export const useStripePromise = (options = {}) => {
    const getStripePromise = useGetStripePromise(options);
    return useMemo(() => getStripePromise(), [getStripePromise]);
};
//# sourceMappingURL=useStripePromise.js.map